<div class="dropdown nbc-dropdown {{nbcClasses}}"
     id="div_id_{{name}}" dropdown>
  <button *ngIf="nbcDisabled"
          type="button" class="text-start form-control {{nbcSize}}"
          name="dis_{{name}}"
          [disabled]="nbcDisabled || !isAuthorized">
    <span>
      {{ initialType }}
      <i class="fa fa-sort float-end mt-1 ps-1"></i>
    </span>
  </button>
  <button *ngIf="!nbcDisabled" dropdownToggle
          name="enable_{{name}}"
          type="button" class="text-start form-control {{nbcSize}}"
          [ngStyle]="{'border-right':nbcRequired?'3px solid #ffc800':''}"
          authenticate-user="{{nbcAuthenticateUser}}"
          authenticate-command="{{nbcAuthenticateCommand}}"
          [disabled]="((!internalSource || internalSource.length<1)&& nbcDisableEmptyList)|| !isAuthorized">
    {{ initialType }}
    <span class="fa fa-sort float-end mt-1 ps-1"></span>
  </button>
  <ul *dropdownMenu class="dropdown-menu" id="menu_{{name}}"
      role="menu">
    <ng-container *ngIf="isAuthorized">
      <li *ngFor="let event of internalSource" name="{{event[display]}}"
          (click)="closeDropdown();onTypeSelect(event);"
          role="presentation">
        <a class="dropdown-item" role="menuitem" tabindex="-1">{{event[display]}}</a>
      </li>
    </ng-container>
  </ul>
</div>
